import { hostname } from "src/HostName";
import axios from "axios";
import { axiosPrivate } from "src/utils/axios";

export const getAgentById = async (agentId) => {
  try {
    const options = {
      method: "GET",
      url: `${hostname}agent_byId/${agentId}`,
    };
    const data = await axios.request(options);
    return data;
  } catch (error) {
    return error.message;
  }
};

export const getUserById = async (userId) => {
  try {
    // const options = {
    //   method: "GET",
    //   url: `${hostname}get_user_byid/${userId}`,
    // };
    const data = await axiosPrivate.get(`get_user_byid/${userId}`)
    // const data = await axios.request(options);
    return data;
  } catch (error) {
    return error.message;
  }
};
